import React from "react";

const LengthenStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.19922 2.75C1.78501 2.75 1.44922 3.08579 1.44922 3.5C1.44922 3.91421 1.78501 4.25 2.19922 4.25H13.7992C14.2134 4.25 14.5492 3.91421 14.5492 3.5C14.5492 3.08579 14.2134 2.75 13.7992 2.75H2.19922ZM2.19922 11.75C1.78501 11.75 1.44922 12.0858 1.44922 12.5C1.44922 12.9142 1.78501 13.25 2.19922 13.25H7.79922C8.21343 13.25 8.54922 12.9142 8.54922 12.5C8.54922 12.0858 8.21343 11.75 7.79922 11.75H2.19922ZM1.44922 6.5C1.44922 6.08579 1.78501 5.75 2.19922 5.75H13.7992C14.2134 5.75 14.5492 6.08579 14.5492 6.5C14.5492 6.91421 14.2134 7.25 13.7992 7.25H2.19922C1.78501 7.25 1.44922 6.91421 1.44922 6.5ZM2.19922 8.75C1.78501 8.75 1.44922 9.08579 1.44922 9.5C1.44922 9.91421 1.78501 10.25 2.19922 10.25H13.7992C14.2134 10.25 14.5492 9.91421 14.5492 9.5C14.5492 9.08579 14.2134 8.75 13.7992 8.75H2.19922Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LengthenStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;